const React = require('react');
const { useEffect, useState } = React;
const { default: Styled } = require('styled-components');
const { context } = require('app-context');

const internals = {};

module.exports = function FounderCaption({ viewer, profileId, schoolId }) {

    const scope = `${schoolId}:${viewer?.id}:${viewer?.roleId}:${profileId}`;
    const [result, setResult] = useState(null);
    const eligible = [2, 12].includes(viewer?.roleId) && Number.isInteger(profileId) && Number.isInteger(schoolId);
    const { Caption } = internals;
    useEffect(() => {

        let current = true;
        setResult(null);
        if (eligible) {
            context.api.nearpeer.communityLaunch.founder(profileId).then((data) => {

                if (current) { setResult({ scope, data }); }
            }).catch(() => {});
        }

        return () => { current = false; };
    }, [eligible, scope, profileId]);

    if (!eligible || result?.scope !== scope || !result.data.foundingMember ||
        result.data.schoolId !== schoolId || result.data.roleId !== viewer.roleId) {
        return null;
    }

    return <Caption>{result.data.label}</Caption>;
};

internals.Caption = Styled.div`
    margin-top: 6px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
`;
